<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>MicroSync Technologies Family</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>MicroSync Technologies Family</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- About -->
<section class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="about-image-warp image-two"></div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content warp">
                    <span>About Our Family</span>
                    <h3 style="text-transform:none;">Our main pillers are the family members in all areas who help
                        business to grow efficiently </h3>
                    <div class="bar"></div>
                    <p>MicroSync Technologies Management team includes industry experts who carries extensive
                        experience in their
                        respective domains,
                        committed to MicroSync Technologies vision and strategic focus. Believes in setting right
                        direction, pace,
                        managing and motivating to achieve greater heights.</p>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About -->